import * as CL from '@design-system/component-library';
import { dsClass } from '../../../../../../common/constants/dsClasses';
import { t, userInformationCopiedMsg, userInformationCopiedToAllMsg } from '../../../../../../common/i18n';

interface CopyUserInfoSuccessMessageProps {
  isCopiedUserInfo?: boolean;
  onClose: () => void;
}

export const CopyUserInfoSuccessMessage = ({ isCopiedUserInfo, onClose }: CopyUserInfoSuccessMessageProps) => (
  <div className="copy-user-info-success-message">
    <CL.Icon icon="check" size="s" />
    <span className={dsClass.PADDING_HORIZONTAL_2}>
      {isCopiedUserInfo ? t.GUWY(userInformationCopiedMsg) : t.GUWX(userInformationCopiedToAllMsg)}
    </span>
    <CL.Button aria-label="closeSuccessMessage" color="link-button" onClick={() => onClose()} size="s">
      <CL.Icon icon="close" size="s" color="primary-blue-800" />
    </CL.Button>
  </div>
);
